<template>

	<el-container>
		<el-header>
			<vheader v-on:LoginBox="LoginBox"></vheader>
		</el-header>
		<el-main>
		<div class="help-banner-container">
			<div class="banner-img"></div>
		</div>
		<el-row class="container help-container">
			<el-col :span="5" class="help-left-column">
			  <help-menu></help-menu>
			</el-col>
			<el-col :span="19" class="help-right-column">
			  <router-view></router-view>
			</el-col>
		  </el-row>
		</el-main>
		<el-footer height="auto">
			<vfooter></vfooter>
		</el-footer>
		<LoginBox ref="LoginBox"></LoginBox>
		<FloatButton></FloatButton>

	</el-container>

</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Menu from '@/components/views/help/Menu.vue'
import LoginBox from '@/components/LoginBox'
import FloatButton from '@/components/FloatButton'

export default {
	name: 'HelpLayout',
	components: {
		'vheader': Header,
		'vfooter': Footer,
		'helpMenu': Menu,
		'LoginBox' : LoginBox,
		'FloatButton' : FloatButton,
	},
	methods: {
		LoginBox(args){
			this.$refs.LoginBox[args.methods]();
		},
	},
	created() {
	},
	mounted() {

	},
}
</script>

<style>
.help-banner-container .banner-img {background: url(~assets/images/help/banner.jpg) center center / cover rgb(0, 0, 0);width:100%;height:180px;}

.help-container {
	margin-top: 20px;
	margin-bottom: 20px;
	min-height: 600px;	
	box-shadow: 1px 1px 10px #ddd;
	padding: 0 !important;
	
}

.help-right-content {
	line-height: 24px;
}


.help-container {
	overflow:hidden;
	font-size: 15px;
}

.help-container .help-left-column .el-menu {
	border-right: none;
	border-right: 1px solid #eaeaea;
	margin-bottom: -100000px;
	padding-bottom: 100000px;
}

.help-container .help-left-column {
	background-color: white;
}

.help-container .help-left-column .help-left-title {
	border-right: 1px solid #eaeaea;
	font-size: 18px;
    font-weight: 700;
    padding: 25px;
	border-bottom: 1px solid #eaeaea;
}

.help-container .help-right-column .help-right-content {
	margin-top: 60px;
    overflow: auto;
    padding: 0 60px 60px;
}

.help-container .help-right-column {
	background-color: white;
	min-height: 600px;
}

.help-container .help-right-column .title {
	height:45px;
	line-height:45px;
    background: #f9f9f9;
    border-bottom: 0px solid #eaeaea;
    padding: 0 30px;
	font-size:16px;
}
.help-container .help-left-column .el-menu-item{
	font-size:16px;
	height: 45px;
	line-height: 45px;
	padding-left:25px !important;
	color:#666;
}

.help-container .el-collapse-item__header {
	font-size:15px;
	color:#009cdd;
}
.help-container .el-collapse-item__content {
	font-size:15px;
	color:#666;
}
</style>


// WEBPACK FOOTER //
// src/components/layouts/Help.vue